import { render, staticRenderFns } from "./partyGroupConfigList.vue?vue&type=template&id=48c0535b"
import script from "./partyGroupConfigList.vue?vue&type=script&lang=js"
export * from "./partyGroupConfigList.vue?vue&type=script&lang=js"
import style0 from "./partyGroupConfigList.vue?vue&type=style&index=0&id=48c0535b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports